import { LAYER } from 'js/components/common/PopupManager/layers';
import { ADD_POPUP } from 'js/components/common/PopupManager/store/actions';
import { CommonPopup } from 'js/components/common/popups/CommonPopup/CommonPopup';

/**
 * @param props {Object}
 * @param [props.id] {string}
 * @param [props.title] {string}
 * @param [props.content] {string}
 * @param [props.additionalContent] {string}
 * @param [props.onClose] {Function}
 * @param [props.btnTitle] {string}
 * @param [props.closeAll] {boolean}
 * @param [props.layer] {string}
 * @param [props.isModal] {boolean}
 * @param [props.articleId] {string}
 * @param [props.buttons] {Object[]}
 */
export const showCommonPopupAction = ({
    id,
    title,
    content,
    additionalContent,
    onClose,
    btnTitle,
    closeAll,
    layer = LAYER.COMMON,
    isModal = false,
    articleId,
    buttons,
    ...other
}) => ({
    type: ADD_POPUP,
    payload: {
        id,
        component: CommonPopup,
        title,
        content,
        additionalContent,
        onClose,
        btnTitle,
        closeAll,
        layer,
        isModal,
        articleId,
        buttons,
        ...other
    }
});
